var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 566.48 97.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#000;stroke-miterlimit:10;stroke-width:0.5px;}.cls-2{fill:#0a3b5b;}.cls-3{fill:#187db5;}.cls-4{fill:#05aad8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "principal_01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.6,48.29a19.88,19.88,0,0,1-1,3.89,12.85,12.85,0,0,1-12.29,9.23c-8,0-13.41-6.3-13.41-16,0-9.48,5.45-16,13.66-16,9.7,0,11.83,9,11.83,9h.13s-.25-3-.25-3.79V22.49h1.25l.1,25.93m-1.35-3c0-10.09-5.39-14.93-11.71-14.93-7.08,0-12.4,5.75-12.4,14.87,0,9.36,5.38,14.8,12.08,14.8C424.18,60.19,428.25,53,428.25,45.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.81,29.34h1.25V61.52h-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.42,29.34h1.25V60.66h-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M528.8,55.42V52.11l.12.37c.07,0-2.81,8.93-12,8.93-5,0-10.33-2.69-10.33-8.93,0-9.67,13-9.24,18.16-9.24h4V41c0-7.83-3.95-10.46-9.52-10.46a15.31,15.31,0,0,0-9.4,3l-.75-1a16.65,16.65,0,0,1,10.21-3.19c7.08,0,10.71,4,10.71,11.57V61.52H528.8Zm0-11h-3.7c-5.13,0-17.22-.67-17.22,7.83,0,4.47,3.38,7.9,9,7.9,7.82,0,12-7,12-12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M537.21,29.34h1.25V60.66h-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.5,56.34a14.37,14.37,0,0,0,9.77,3.85c5,0,8.71-2.57,8.71-6.85s-4.07-5.88-8.65-7.47c-4.76-1.72-9.33-3.61-9.33-8.75,0-5,4-7.78,9.58-7.78a14.6,14.6,0,0,1,9,2.76l-.81,1s-2.76-2.57-8.15-2.57c-4.44,0-8.33,1.95-8.33,6.61s3.76,5.93,8.65,7.65c4.69,1.71,9.33,3.43,9.33,8.57,0,4.53-3.76,8.07-10,8.07a15.34,15.34,0,0,1-10.65-4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M490,30.65h-4.14V29.56H490V22.27h1.25v7.29h8.2v1.09h-8.2V50.86c0,8.36,4.95,9.62,7.64,9.62a8.46,8.46,0,0,0,1.31-.11v1.14a5.78,5.78,0,0,1-1.25.12c-2.82,0-8.95-1.09-8.95-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180,44.57v.61c0,9.24,6.58,15.12,14.34,15.12a15.45,15.45,0,0,0,10.27-3.86l.76,1a16.91,16.91,0,0,1-11,4c-8.39,0-15.59-6.18-15.59-16.21,0-10.29,7-15.86,14.71-15.86,8.21,0,12.41,6.06,12.41,13.22v1.9Zm.06-1.22H204.6c0-8.88-5.26-12.73-11.15-12.73S180.87,34.59,180.05,43.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.25,42.79a28.5,28.5,0,0,1,1.15-5.31c2.1-5.23,5.3-8,10.68-8a15.41,15.41,0,0,1,1.82.13v1.21a14.64,14.64,0,0,0-1.63-.13c-7.83,0-10.77,8.27-10.77,15.34V61.52h-1.25V42.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.73,44.57v.61c0,9.24,6.58,15.12,14.35,15.12a15.45,15.45,0,0,0,10.27-3.86l.75,1a16.9,16.9,0,0,1-11,4c-8.4,0-15.6-6.18-15.6-16.21,0-10.29,7-15.86,14.72-15.86,8.21,0,12.4,6.06,12.4,13.22v1.9Zm.07-1.22h24.55c0-8.88-5.26-12.73-11.15-12.73S232.61,34.59,231.8,43.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.14,42a22.85,22.85,0,0,1,.95-4.15c1.31-3.59,3.4-8.38,11.58-8.38,7.58,0,12.69,4.7,12.69,12.09v20H289.1V42c0-5.7-3.66-11.34-11.43-11.34-7.2,0-10.08,5-10.91,9.85a40.37,40.37,0,0,0-.52,6.87V61.52H265l.15-19.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.27,44.57v.61c0,9.24,6.58,15.12,14.35,15.12a15.48,15.48,0,0,0,10.27-3.86l.75,1a16.9,16.9,0,0,1-11,4c-8.4,0-15.6-6.18-15.6-16.21,0-10.29,7-15.86,14.72-15.86,8.2,0,12.4,6.06,12.4,13.22v1.9Zm.07-1.22h24.55c0-8.88-5.26-12.73-11.15-12.73S321.15,34.59,320.34,43.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.8,56.44a14.4,14.4,0,0,0,9.78,3.86c4.94,0,8.7-2.57,8.7-6.85s-4.07-5.88-8.64-7.47c-4.76-1.72-9.33-3.61-9.33-8.75,0-5,3.94-7.78,9.58-7.78a14.6,14.6,0,0,1,9,2.76l-.82,1s-2.76-2.57-8.14-2.57c-4.45,0-8.33,1.95-8.33,6.61s3.76,5.93,8.64,7.65c4.7,1.71,9.33,3.42,9.33,8.57,0,4.52-3.75,8.07-9.95,8.07a15.31,15.31,0,0,1-10.65-4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.65,30.54h-4.13V29.45h4.13V22.17h1.25v7.28h8.21v1.09H302.9V50.75c0,8.36,5,9.63,7.64,9.63a8,8,0,0,0,1.32-.12v1.15a6.41,6.41,0,0,1-1.25.11c-2.82,0-9-1.09-9-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.43,40.92c0,4.93-.08,19.74-.08,19.74,0,9-6.17,12.58-12.74,12.58a18.23,18.23,0,0,1-9-2.32l.53-1a17.35,17.35,0,0,0,8.45,2.2c6.16,0,11.56-3.3,11.56-11.54V55.16c0-1.4.06-2.9.06-2.9l.06.4c-1.64,4.7-5,8.86-10.62,8.86-7.46,0-12.85-6.91-12.85-16.74,0-9.4,4.87-15.33,12.61-15.33,4.93,0,12,3.46,12,11.47M170.23,45c0-11-4.93-14.42-10.8-14.42-7.22,0-11.44,5.25-11.44,14.11,0,9.47,4.75,15.58,11.68,15.58C165.36,60.3,170.23,55.9,170.23,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.06,42V60.55c0,9-6.16,12.58-12.73,12.58a18.23,18.23,0,0,1-9-2.32l.52-1a17.41,17.41,0,0,0,8.46,2.2c6.16,0,11.56-3.3,11.56-11.54V55.06a13.62,13.62,0,0,1,.23-2.51H469c-1.64,4.7-5,8.86-10.62,8.86-7.45,0-12.85-6.9-12.85-16.74,0-9.4,4.87-15.33,12.62-15.33,4.93,0,11.91,3.11,11.91,12.7M469,44.92c0-11-4.93-14.41-10.8-14.41-7.22,0-11.45,5.25-11.45,14.1,0,9.47,4.76,15.58,11.68,15.58C464.08,60.19,469,55.79,469,44.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 55.6,
    cy: 27.33,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 55.6,
    cy: 70.76,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75.17,
    cy: 59.68,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75.17,
    cy: 37.51,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.86,
    cy: 37.51,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 35.86,
    cy: 14.95,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 75.05,
    cy: 14.95,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 82.4,
    cy: 2.2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 29.1,
    cy: 2.35,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2,
    cy: 48.62,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 28.83,
    cy: 95.04,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 82.79,
    cy: 95.04,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 109.21,
    cy: 48.62,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 55.6,
    cy: 2.2,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 15.4,
    cy: 25.41,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 15.4,
    cy: 71.83,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 55.41,
    cy: 95.04,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.8,
    cy: 71.83,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.8,
    cy: 25.41,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 94.49,
    cy: 48.62,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 75.05,
    cy: 82.3,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 35.07,
    cy: 82.76,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16.72,
    cy: 48.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.86,
    cy: 59,
    r: 3.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9081f10acc5b81be41865b35f321ced4.svg";
export { ForwardRef as ReactComponent };